import { render, staticRenderFns } from "./MasterBatchForm.vue?vue&type=template&id=b945853c&scoped=true"
import script from "./MasterBatchForm.vue?vue&type=script&lang=js"
export * from "./MasterBatchForm.vue?vue&type=script&lang=js"
import style0 from "./MasterBatchForm.vue?vue&type=style&index=0&id=b945853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b945853c",
  null
  
)

export default component.exports